




import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class SingleSelectorComponent extends Vue {
  @Prop() value?: any;
  @Prop() label?: string;
  @Prop() items?: any[];
  @Prop() itemText?: string;
  @Prop() itemValue?: string;

  current?: any = null;

  created() {
    if (this.value) this.current = this.value;
  }

  @Watch("value")
  onValueChange() {
    this.current = this.value;
  }

  @Watch("current")
  onChange() {
    this.$emit("input", this.current);
  }
}
